/* global ga */
Wee.fn.make('forms', {
	init: function() {
		var scope = this,
			$form = $('ref:genForm'),
			$referringProject = $('ref:referringProject');

		this.prettifyForm();

		if ($referringProject.length > 0) {
			var project = $.routes.uri().query.project,
				formatted = project.replace(/-/g, ' ').replace(/\b\w/g, function(el) {
					return el.toUpperCase();
				});

			$referringProject.val(formatted);

			$form.find('form').append($referringProject);
		}

		$form.find('form').on('submit', function(e) {
			scope.removeFormErrors();

			if (scope.formIsComplete()) {
				// Disable submit button/input, so it will prevent multiple submissions
				scope.disableSubmitButton($form, true);

				ga('set', 'page', '/' + $.get('completionUrlTitle') + '/thank-you');

				ga('send', 'pageview');

				return;
			}

			$(Wee._body).tween({
				scrollTop: $('ref:genForm').offset().top - 150
			});

			e.preventDefault();
		});
	},

	prettifyForm: function() {
		var $genForm = $('ref:genForm');

		$genForm.find('form')
			.contents()
			.filter(function() {
				return this.nodeType === 3;
			})
			.wrap('<label />');

		if ($.get('isSalesForce')) {
			$genForm.find('input, select, textarea').not('[type="hidden"]').each(function(el) {
				var $el = $(el),
					$label = $el.prev(),
					$wrap = $('<div class="form__group" />');

				$label.appendTo($wrap);
				$el.wrap($wrap);
			});
		} else {
			var $submitInput = $genForm.find('.form__group.-nonfield_submit');

			$genForm.find('form').append($submitInput);
		}

		Wee.dropdown.init({
			selector: '.form__group select',
			appPrefix: 'drop',
			rootModifier: '-salesforce'
		});

		$genForm.find('br').remove();

		this.handleFileFields();
	},

	handleFileFields: function() {
		var $fileInputs = $('ref:genForm').find('input[type="file"]');

		$fileInputs.each(function(el) {
			var $el = $(el),
				id = $el.attr('id');

			$el.hide();
			$el.prev().attr('for', id).addClass('button -salesforce');
		});

		$fileInputs.on('change', function() {
			var fileName = $(this).val().split('\\').pop();

			if (fileName) {
				$(this).prev().text(fileName);
			}
		});
	},

	formIsComplete: function() {
		var scope = this,
			textFields = scope.textFieldsAreFilled(),
			emailFormats = scope.emailFormatsAreCorrect(),
			dropdownFields = scope.dropdownsAreSelected(),
			radiosSelected = scope.radioFieldsAreSelected(),
			checkboxesSelected = scope.checkboxFieldsAreSelected();

		return textFields && emailFormats && dropdownFields && radiosSelected && checkboxesSelected;
	},

	textFieldsAreFilled: function() {
		var inputs = $('ref:genForm').find('input[type=text]'),
			output = true,
			scope = this;

		inputs.each(function(el) {
			var inputLabel = $(el).prev('label').html();

			if (el.value === '' && inputLabel.includes('*')) {
				scope.addFormError(el, 'blank');

				output = false;
			}
		});

		return output;
	},

	emailFormatsAreCorrect: function() {
		var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*@[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*\.[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{2,}/,
			$inputs = $('ref:emailFormat'),
			output = true,
			scope = this;

		$inputs.each(function(el) {
			if (! el.value) {
				return;
			}

			if (! regex.test(el.value)) {
				output = false;

				scope.addFormError(el, 'emailFormat');
			}
		});

		return output;
	},

	dropdownsAreSelected: function() {
		var $wrappers = $('ref:genForm').find('.dropdown'),
			output = true,
			scope = this;

		$wrappers.each(function(wrapper) {
			var el = wrapper.previousSibling;

			if (! el.value) {
				// The visual dropdown is being passed here, instead of the <select> element
				scope.addFormError($(el).next('.dropdown'), 'dropdownNotSelected');

				output = false;
			}
		});

		return output;
	},

	radioFieldsAreSelected: function() {
		var $wrapper = $('ref:genForm').find('.form__group.-radio'),
			output = true,
			scope = this;

		$wrapper.each(function(wrapper) {
			var $wrapper = $(wrapper),
				el = $wrapper.find('input[type=radio]:checked');

			if (! el.length) {
				scope.addFormError($wrapper.find('.radio-block'), 'noSelection');

				output = false;
			}
		});

		return output;
	},

	checkboxFieldsAreSelected: function() {
		var $wrapper = $('ref:genForm').find('.form__group.-checkbox_group'),
			output = true,
			scope = this;

		$wrapper.each(function(wrapper) {
			var $wrapper = $(wrapper),
				el = $wrapper.find('input[type=checkbox]:checked');

			if (! el.length) {
				scope.addFormError($wrapper.find('.-checkbox_group').last(), 'noSelection');

				output = false;
			}
		});

		return output;
	},

	addFormError: function(el, type) {
		var responses = {
			blank: 'This field can\'t be blank.',
			emailFormat: 'Your email doesn\'t appear to be formatted properly.',
			dropdownNotSelected: 'Please select an option.',
			noSelection: 'Please select an option.'
		};

		$(el).after('<div class="form-error" data-ref="formError">' + responses[type] + '</div>');

		$.setRef();
	},

	removeFormErrors: function() {
		$('ref:formError').remove();
	},

	disableSubmitButton: function(form, disabled) {
		form.find('button[type="submit"], input[type="submit"]').prop('disabled', disabled);
	}
});